import { render, staticRenderFns } from "./EquipoPivotTable.vue?vue&type=template&id=3673b444"
import script from "./EquipoPivotTable.vue?vue&type=script&lang=js"
export * from "./EquipoPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports